import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../../../constants/qa'
import { SUBMENU_PARAM_ARCHIVE_VALUE } from '../../../../../../constants/route'
import { ConfirmationModal } from '../../../../../Confirmation'
import {
  getListingUnitLabel,
  LISTING_ACTION_RESTORE,
} from '../../../../../RentalPortalListing'
import { useListingProfileContext } from '../useListingProfileContext'
import { useListingProfilePerformAction } from '../useListingProfilePerformAction'

import RestoreIcon from '../../../../../../icons/restore.svg'

export function useListingProfileRestoreAction() {
  const { t } = useTranslation()

  const { handleCloseModal, handleEntityReload, listingData, setModal } =
    useListingProfileContext()

  const { handlePerformAction } = useListingProfilePerformAction({
    errorTitleKey: 'RentalPortal.ArchiveRestoreErrorKey',
    sub: SUBMENU_PARAM_ARCHIVE_VALUE,
    onSuccess: handleEntityReload,
  })

  function handleSubmitRestore() {
    handlePerformAction(LISTING_ACTION_RESTORE)
  }

  function handleClickRestore() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitProps: { beforeIconProps: { Icon: RestoreIcon } },
          submitText: t('RentalPortal.ListingRestoreBtnKey'),
        }}
        description={t('RentalPortal.ListingRestoreConfirmationTextKey', {
          name: getListingUnitLabel({ listing: listingData, t }),
        })}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitRestore}
      />
    )
  }

  return { handleClickRestore }
}
